import { Admin, Resource } from 'react-admin';
import { authProvider } from './authProvider';
import { dataProvider } from './dataProvider';
import { Dashboard } from './Dashboard';
import { theme } from './theme';
import { CustomLayout } from './layout/CustomLayout';
import { CoinList, CoinEdit, CoinCreate, CoinShow } from './resources/coins';
import { CategoryList, CategoryEdit, CategoryCreate, CategoryShow } from './resources/categories';
import { VerifiedExchangeList, VerifiedExchangeEdit, VerifiedExchangeCreate, VerifiedExchangeShow } from './resources/verifiedExchanges';
import { PlatformList, PlatformEdit, PlatformCreate, PlatformShow } from './resources/platforms';
import { ChainList, ChainEdit, ChainCreate, ChainShow } from './resources/chains';
import { FundList, FundEdit, FundCreate, FundShow } from './resources/funds';
import { TreasuryEntityList, TreasuryEntityEdit, TreasuryEntityCreate, TreasuryEntityShow } from './resources/treasuryEntities';
import { TreasuryList, TreasuryEdit, TreasuryCreate, TreasuryShow } from './resources/treasuries';
import { LanguageList, LanguageEdit, LanguageCreate, LanguageShow } from './resources/languages';
import { ReportList, ReportEdit, ReportCreate, ReportShow } from './resources/reports';
import { AddressLabelList, AddressLabelEdit, AddressLabelCreate, AddressLabelShow } from './resources/addressLabels';
import { EvmMethodLabelList, EvmMethodLabelEdit, EvmMethodLabelCreate, EvmMethodLabelShow } from './resources/evmMethodLabels';
import { UpdateStateList, UpdateStateEdit, UpdateStateCreate, UpdateStateShow } from './resources/updateStates';

function App() {
  return (
    <Admin
      authProvider={authProvider}
      dataProvider={dataProvider}
      dashboard={Dashboard}
      theme={theme}
      layout={CustomLayout}
      title="Markets Admin"
    >
      <Resource
        name="coins"
        list={CoinList}
        edit={CoinEdit}
        create={CoinCreate}
        show={CoinShow}
      />
      <Resource
        name="categories"
        list={CategoryList}
        edit={CategoryEdit}
        create={CategoryCreate}
        show={CategoryShow}
      />
      <Resource
        name="verified_exchanges"
        list={VerifiedExchangeList}
        edit={VerifiedExchangeEdit}
        create={VerifiedExchangeCreate}
        show={VerifiedExchangeShow}
      />
      <Resource
        name="platforms"
        list={PlatformList}
        edit={PlatformEdit}
        create={PlatformCreate}
        show={PlatformShow}
      />
      <Resource
        name="chains"
        list={ChainList}
        edit={ChainEdit}
        create={ChainCreate}
        show={ChainShow}
      />
      <Resource
        name="funds"
        list={FundList}
        edit={FundEdit}
        create={FundCreate}
        show={FundShow}
      />
      <Resource
        name="treasury_entities"
        list={TreasuryEntityList}
        edit={TreasuryEntityEdit}
        create={TreasuryEntityCreate}
        show={TreasuryEntityShow}
      />
      <Resource
        name="treasuries"
        list={TreasuryList}
        edit={TreasuryEdit}
        create={TreasuryCreate}
        show={TreasuryShow}
      />
      <Resource
        name="languages"
        list={LanguageList}
        edit={LanguageEdit}
        create={LanguageCreate}
        show={LanguageShow}
      />
      <Resource
        name="reports"
        list={ReportList}
        edit={ReportEdit}
        create={ReportCreate}
        show={ReportShow}
      />
      <Resource
        name="address_labels"
        list={AddressLabelList}
        edit={AddressLabelEdit}
        create={AddressLabelCreate}
        show={AddressLabelShow}
      />
      <Resource
        name="evm_method_labels"
        list={EvmMethodLabelList}
        edit={EvmMethodLabelEdit}
        create={EvmMethodLabelCreate}
        show={EvmMethodLabelShow}
      />
      <Resource
        name="update_states"
        list={UpdateStateList}
        edit={UpdateStateEdit}
        create={UpdateStateCreate}
        show={UpdateStateShow}
      />
    </Admin>
  );
}

export default App;
